module.exports = __webpack_public_path__ + "img/raw.614ec394.png";